import { MapComponent, MapMode } from '@ekt-group/map-component';
import React, { useRef, useState, useEffect } from 'react';

import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import { useFilterParams } from '@/hooks/use-filter-params';
import { useLocale } from '@/hooks/use-locale';

const DEFAULT_OBJECT_ITEM_ID = 218506;
const DEFAULT_RADIUS = 1000;
const DEFAULT_DAYS_AMOUNT = 30;

export const AdditionalDischargesVisualizer = () => {
  const { filters, setFilterValue } = useFilterParams(['objectItemId']);
  const objectItemIdRef = useRef<number>(Number(filters.objectItemId) || DEFAULT_OBJECT_ITEM_ID);
  const radiusRef = useRef<number>(DEFAULT_RADIUS);
  const daysAmountToIncludeRef = useRef<number>(DEFAULT_DAYS_AMOUNT);

  const [key, setKey] = useState<number>(1);
  const { currentLocale } = useLocale();

  useEffect(() => {
    if (filters.objectItemId) {
      objectItemIdRef.current = Number(filters.objectItemId);
    }
  }, [filters.objectItemId]);

  const handleInputChange = (ref: React.MutableRefObject<number>, filterName?: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    if (!isNaN(value)) {
      ref.current = value;
      if (filterName) {
        setFilterValue(filterName, value.toString());
      }
    }
  };

  return (
    <div>
      <div className="flex gap-4 flex-wrap items-center my-2">
        <div className="element-wrapper">
          <Input label={'Object item id'} value={objectItemIdRef.current} onChange={handleInputChange(objectItemIdRef, 'objectItemId')} />
        </div>
        <div className="element-wrapper">
          <Input label={'Radius'} defaultValue={radiusRef.current} onChange={handleInputChange(radiusRef)} />
        </div>
        <div className="element-wrapper">
          <Input
            label={'Days amount to include'}
            defaultValue={daysAmountToIncludeRef.current}
            onChange={handleInputChange(daysAmountToIncludeRef)}
          />
        </div>
        <Button onClick={() => setKey((value) => value + 1)}>Update</Button>
      </div>
      <div id="map-wrapper" style={{ height: '70vh' }}>
        <MapComponent
          key={key}
          mode={MapMode.AdditionalDischargeOrder}
          locale={currentLocale}
          objectItemId={objectItemIdRef.current}
          radius={radiusRef.current}
          daysAmountToInclude={daysAmountToIncludeRef.current}
          generalPurposesHostUrl={import.meta.env.VITE_GENERAL_PURPOSE_HOST_URL}
        />
      </div>
    </div>
  );
};
